import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface State {
  error: Error | null;
}

// 兜底 ErrorBoundary：任何子树渲染错误都不会白屏，而是给出可重试提示。
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[web-console] 渲染错误：', error, info);
  }

  private reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 'var(--pad)' }}>
          <div className="notice bad">
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 650, marginBottom: 4 }}>页面渲染出错</div>
              <div className="muted" style={{ fontFamily: 'var(--mono)', fontSize: 12 }}>
                {this.state.error.message}
              </div>
              <div style={{ marginTop: 6, fontSize: 12, color: 'var(--ink-3)' }}>
                这通常是后端契约变化或数据字段缺失导致。若持续出现请查看控制台日志。
              </div>
            </div>
            <button className="btn" onClick={this.reset}>重试</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
